import React from 'react';
import ReactDOM from 'react-dom';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/global.css';
import App from './App';
import GoogleCallback from './pages/login/GoogleCallback';

const root = document.getElementById('root');
const isGoogleCallback = window.location.pathname === '/auth/google/callback';

ReactDOM.render(
  <React.StrictMode>
    {isGoogleCallback ? <GoogleCallback /> : <App />}
  </React.StrictMode>,
  root
);
